/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 * - storefront money: display the euro symbol after the amount.
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

function formatEuroTextNode(node) {
  const parent = node.parentElement;
  if (!node.nodeValue || !parent) return;

  const skippedTags = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'OPTION']);
  if (skippedTags.has(parent.tagName)) return;

  const current = node.nodeValue;
  if (!current.includes('€')) return;

  const next = current.replace(
    /€\s*((?:\d{1,3}(?:[.\u00A0\u202F ]\d{3})+|\d+)(?:,\d{2})?)/g,
    '$1\u00A0€'
  );

  if (next !== current) node.nodeValue = next;
}

function formatEuroTree(root) {
  if (!root) return;

  if (root.nodeType === Node.TEXT_NODE) {
    formatEuroTextNode(root);
    return;
  }

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let node;
  while ((node = walker.nextNode())) formatEuroTextNode(node);
}

function initEuroPricePosition() {
  if (!document.body) return;

  formatEuroTree(document.body);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'characterData') {
        formatEuroTextNode(mutation.target);
        continue;
      }

      mutation.addedNodes.forEach((node) => formatEuroTree(node));
    }
  });

  observer.observe(document.body, {
    subtree: true,
    childList: true,
    characterData: true,
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initEuroPricePosition, { once: true });
} else {
  initEuroPricePosition();
}
